import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_BASE_URL from "./api";
import "./UserAuth.css";

export default function UserLogin() {
  const navigate = useNavigate();

  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/user/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            login_id: loginId,
            password
          })
        }
      );

      const data = await response.json();
      console.log("LOGIN RESPONSE:", data);

      if (data.success) {
        console.log("LOGIN RESPONSE:", data);

        const email = data.user?.email;
        const user_mobileno = data.user?.mobile;

        localStorage.setItem("userEmail", email);
        localStorage.setItem("user_mobileno", user_mobileno);

        console.log("Stored Email:", email);
        console.log("Stored Mobile:", user_mobileno);

        alert("Login Successful");
        navigate("/admin-dashboard");
      } else {
        alert(data.message || "Invalid Login");
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>User Login</h2>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Email or Mobile Number"
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit">
            Login
          </button>
        </form>

        <p>
          New User?{" "}
          <Link to="/user-register">
            Register Here
          </Link>
        </p>
      </div>
    </div>
  );
}